import { KpiSectionTooltipProps } from "./types";

export const KPI_TOOLTIPS: KpiSectionTooltipProps = {
  kpiName: {
    title: "KPI Name",
    text: "The performance indicator this initiative is designed to move.",
    chip: "Input",
  },
  unit: {
    title: "Unit",
    text: "The unit of measurement for this KPI. Baseline and improvement values are entered in this unit.",
    chip: "Input",
  },
  baselineValue: {
    title: "Baseline Value",
    text: "The current value of the KPI, before this initiative is delivered.",
    chip: "Input",
  },
  expectedAnnualImprovement: {
    title: "Expected Annual Improvement",
    text: "How much the KPI is expected to change each year, in the same unit as the baseline.",
    chip: "Input",
  },
  direction: {
    title: "Direction",
    text: "Whether the KPI needs to go down (Reduction) or up (Increase) to count as improvement.",
    chip: "Input",
  },
  projectedImprovement: {
    title: "Projected Improvement",
    text: "The expected improvement in the KPI at the end of the initiative's lifetime, calculated based on the baseline, expected annual improvement, and direction.",
    formula: "(Expected Annual Improvement ÷ Baseline Value) × 100",
    chip: "Calculated",
  },
  fromBaseline: {
    title: "From baseline",
    text: "Shows the starting value of the KPI and what it becomes once the improvement is delivered.",
    chip: "Calculated",
  },
};
